import ElementResizeDetector from 'element-resize-detector'
import JsPinyin from 'js-pinyin'
import SimpleWebWorker from 'simple-web-worker'

/**
 * 监听document宽高变化
 * 必须在mounted中使用
 * */
let listenDocumentWH = (doc, callback) => {
  let erd = ElementResizeDetector()
  erd.listenTo(doc, element => {
    callback(element.offsetWidth, element.offsetHeight)
  })
}

/**
 * 拼音全拼首字母大写
 * 例：朱亚滨->ZhuYaBin
 * */
let pyFullChars = words => {
  if (words === undefined || words === null || words === '') return ''
  return JsPinyin.getFullChars(words)
}

/**
 * 拼音仅保留首字母并大写
 * 例：朱亚滨->ZYB
 * */
let pyCamelChars = words => {
  if (words === undefined || words === null || words === '') return ''
  return JsPinyin.getCamelChars(words)
}

/**
 * 开启子线程执行方法
 * func为方法名称
 * args为{}传参
 * */
let childWorker = (that, func, args) => {
  if (func === undefined || func === null || func === '') return
  const workerUid = 'worker_' + that.$system.uuid()
  let simpleWebWorker = SimpleWebWorker.create([{ message: workerUid, func() {} }])
  simpleWebWorker.postMessage(workerUid, []).then(() => {
    func(args)
    simpleWebWorker = null
  })
}

/**
 * 加载public中的脚本文件内容并得到数据
 * obj：入参唯一对象
 * scriptFilePath：不带/前缀的脚本文件路径
 * success：回调函数
 * */
let scriptPublicFile = (that, obj, scriptFilePath, success) => {
  if (scriptFilePath === undefined || scriptFilePath === null || scriptFilePath === '') return
  if (success === undefined || success === null || success === '') return
  that.$system.get(that.$store.state.baseUrl + scriptFilePath, {}, false, false, data => success(scriptStr(obj, data)))
}

/**
 * 加载脚本字符串内容并得到数据
 * obj：入参唯一对象
 * scriptStr：脚本字符串
 * */
let scriptStr = (obj, data) => {
  function func(obj) {
    return new Function('obj', data)(obj)
  }
  return func(obj)
}

/**
 * 光标聚焦最后
 * focusClass：具体的光标需要结尾的对象
 * */
let focusEnd = focusClass => {
  if (focusClass === undefined || focusClass === null) return
  // 获取焦点
  focusClass.blur()
  focusClass.focus()
  // 如果是input
  if (focusClass.type === 'text' || focusClass.type === 'textarea') {
    const length = focusClass.value.length
    focusClass.setSelectionRange(length, length)
    return
  }
  // 其他
  if (window.getSelection) {
    const range = window.getSelection()
    range.selectAllChildren(focusClass)
    range.collapseToEnd()
    return
  }
  // 兼容ie10及以下
  if (document.selection) {
    const range = document.selection.createRange()
    range.moveToElementText(focusClass)
    range.collapse(false)
    range.select()
  }
}

/**
 * 字符串转16进制
 * */
let strToHex16 = (str, split) => {
  if (str === undefined || str === null) return null
  str = String(str)
  const hex16List = []
  for (let i = 0, length = str.length; i < length; i++) {
    hex16List[i] = str.charCodeAt(i).toString(16)
  }
  return hex16List.join(split)
}

/**
 * 16进制转字符串
 * */
let hex16ToStr = (hex16, split) => {
  if (hex16 === undefined || hex16 === null) return null
  hex16 = String(hex16)
  const hex16List = hex16.split(split)
  const strList = []
  for (let i = 0, length = hex16List.length; i < length; i++) {
    strList[i] = String.fromCodePoint(parseInt(hex16List[i], 16))
  }
  return strList.join('')
}

export default { listenDocumentWH, pyFullChars, pyCamelChars, childWorker, scriptPublicFile, scriptStr, focusEnd, strToHex16, hex16ToStr }
